module.exports = __webpack_public_path__ + "img/alert.353bf4ea.svg";